import SpinModel from "../../../../vendor_core/core/src/model/SpinModel";
import { ICondition } from "../../../../vendor_core/core/src/states/State";

export default class CRCFreeSpinsWonCondition implements ICondition {
    public check(): boolean {

        return SpinModel.hasFreespinsWon() || (SpinModel.isInFreespins() && SpinModel.freespinsWon > 0);

    }
}
